export default __webpack_public_path__ + "static/media/capBg.f95377c3.svg";